import { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import Home from "./Home/Home";
import AboutPage from "./About/AboutPage";
import ContactPage from "./Contact/ContactPage";
import RecognitionPage from "./Recognition/RecognitionPage";
import BlogPage from "./Blog/BlogPage";
import BlogPost from "./Blog/BlogPost";
import { initAnalytics, trackPageview } from "./lib/analytics";

/** Reset scroll and record a page view whenever the route changes. */
function RouteWatcher() {
  const { pathname } = useLocation();
  useEffect(() => {
    // Init here (idempotent) so gtag is set up before the first page view —
    // this effect runs before the parent's, so initialising in App() would
    // be too late for the initial pageview.
    initAnalytics();
    window.scrollTo(0, 0);
    trackPageview(pathname);
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <Router>
      <RouteWatcher />
      <div className="w-full bg-ink-950">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about_me" element={<AboutPage />} />
          <Route path="/recognition" element={<RecognitionPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/connect_me" element={<ContactPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}
